enum PaymentRemittancesType {
  ANALYTICAL = 'ANALYTICAL',
  SYNTHETIC = 'SYNTHETIC',
}

export default PaymentRemittancesType;
